import {
  createApi,
  fetchBaseQuery,
  skipToken,
} from '@reduxjs/toolkit/query/react';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';

export interface IGetDownloadURLRequest {
  storageLink?: string;
  directLink?: string;
}

const fetchDownloadURL = async (storageLink: string) => {
  if (!storageLink) throw new Error('Storage link is required');

  const storage = getStorage();
  return getDownloadURL(ref(storage, storageLink));
};
export const firebaseApi = createApi({
  reducerPath: 'firebaseApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getDownloadURL: builder.query<string, string | IGetDownloadURLRequest>({
      queryFn: async (request) => {
        const requestPayload: IGetDownloadURLRequest =
          typeof request === 'string' ? { storageLink: request } : request;

        if (requestPayload.directLink) {
          return { data: requestPayload.directLink };
        }

        const url = await fetchDownloadURL(requestPayload.storageLink ?? '');
        return { data: url };
      },
      serializeQueryArgs: ({ queryArgs }) => {
        if (queryArgs === (skipToken as any)) {
          return 'skipToken';
        }

        if (typeof queryArgs === 'string') {
          return decodeURIComponent(queryArgs).split('?')[0];
        }

        return decodeURIComponent(
          queryArgs.directLink || queryArgs.storageLink || 'empty-link',
        ).split('?')[0];
      },
      keepUnusedDataFor: 600,
    }),
  }),
});

export const {
  useGetDownloadURLQuery: useGetDownloadURL,
  useLazyGetDownloadURLQuery: useLazyGetDownloadURL,
} = firebaseApi;
